import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndexPageComponent } from './features/layout/index-page/index-page.component';
import { LoginComponent } from './features/authentication/pages/login/login.component';
import { RequestPasswordResetComponent } from './features/authentication/pages/request-password-reset/request-password-reset.component';
import { ResetPasswordComponent } from './features/authentication/pages/reset-password/reset-password.component';
import { ValidateAccountComponent } from './features/authentication/pages/validate-account/validate-account.component';
import { authBlockGuard } from './core/guards/auth-block.guard';
import { authGuard } from './core/guards/auth.guard';
import { ProfilComponent } from './pages/administrateur/profil/profil.component';
import { MentionsLegalesComponent } from './features/legal/mentions-legales/mentions-legales.component';
import { ConfidentialiteComponent } from './features/legal/confidentialite/confidentialite.component';
import { CgvComponent } from './features/legal/cgv/cgv.component';


const routes: Routes = [

  {path: 'beekids/profil', component :ProfilComponent,canActivate: [authBlockGuard] },

  

  // Authentication Routing Pages
  { path: 'login', component: LoginComponent,canActivate: [authBlockGuard]},
  { path: 'request-password-reset', component: RequestPasswordResetComponent,canActivate: [authBlockGuard] },
  { path: 'reset-password/:token', component: ResetPasswordComponent,canActivate: [authBlockGuard] },
  { path: 'validate-account/:token', component: ValidateAccountComponent ,canActivate: [authBlockGuard]},
  { 
   path: 'beekids', 
   loadChildren: () => import('../../src/app/features/layout/layout.module').then(m => m.LayoutModule) 
 },
  { path: 'enseignant', loadChildren: () => import('./pages/enseignant/enseignant.module').then(m => m.EnseignantModule), canActivate: [authGuard] },
 
  { path: 'super-admin', loadChildren: () => import('./pages/super-admin/super-admin.module').then(m => m.SuperAdminModule) },

  {path: 'home', component :IndexPageComponent },
  { path: 'mentions-legales', component: MentionsLegalesComponent },
  { path: 'confidentialite', component: ConfidentialiteComponent },
  { path: 'cgv', component: CgvComponent },
  { path: '', redirectTo: '/home', pathMatch: 'full' }, // Redirect root URL to /home
  { path: '**', redirectTo: '/home' }



];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { 

}
